module.exports = __webpack_public_path__ + "static/img/1805_1.70e3919.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1805_1.jpg
// module id = kc2v
// module chunks = 1